import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-open-orders',
  templateUrl: './review-open-orders.component.html',
  styleUrls: ['./review-open-orders.component.scss']
})
export class ReviewOpenOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
